import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft, Sparkles, Trash2 } from "lucide-react";

const MOODS = ["😢", "😔", "😕", "😐", "🙂", "😊", "🥰", "✨", "💖", "🌟"];

export default function JournalNew() {
  const nav = useNavigate();
  const [mood, setMood] = useState(5);
  const [content, setContent] = useState("");
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/journal/prompt"); setPrompt(data.prompt); }
      catch {}
    })();
  }, []);

  const submit = async () => {
    if (content.trim().length < 3) return;
    setLoading(true);
    try {
      await api.post("/journal", { mood, content: content.trim() });
      nav("/breakup");
    } finally { setLoading(false); }
  };

  return (
    <div className="app-shell bg-aurora min-h-screen pb-10" data-testid="journal-new-page">
      <div className="px-6 pt-10 pb-5 flex items-center gap-3">
        <button onClick={() => nav("/breakup")} className="text-[#5F7F77]"><ArrowLeft size={20} strokeWidth={1.7} /></button>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-[#5F7F77] font-medium">Deník</p>
          <h1 className="font-display text-3xl text-[#1A2924]">Nový záznam</h1>
        </div>
      </div>

      <div className="px-6 space-y-5">
        {prompt && (
          <div className="rounded-2xl p-4 bg-gradient-to-br from-[#F0E8D6] to-[#EDE5D2] border border-[#DEE7E2] flex items-start gap-2" data-testid="journal-prompt">
            <Sparkles size={16} className="text-[#C9A66B] mt-0.5 shrink-0" />
            <p className="text-sm text-[#1A2924] italic">{prompt}</p>
          </div>
        )}

        <div>
          <label className="label-soft">Jak se dnes cítíš (1–10)</label>
          <div className="flex items-center justify-between gap-1.5">
            {MOODS.map((emoji, i) => {
              const v = i + 1;
              return (
                <button key={v} onClick={() => setMood(v)} data-testid={`mood-${v}`}
                  className={`w-8 h-8 rounded-full text-lg transition-all ${mood === v ? "bg-[#C9A66B] scale-110" : "opacity-50"}`}>
                  {emoji}
                </button>
              );
            })}
          </div>
          <p className="text-center text-xs text-[#5F7F77] mt-2">{mood}/10</p>
        </div>

        <div>
          <label className="label-soft">Co máš na srdci</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={8}
            className="input-field text-sm leading-relaxed"
            placeholder="Piš upřímně. Nikdo jiný to neuvidí. ❤️"
            data-testid="journal-content"
          />
        </div>

        <button onClick={submit} disabled={loading || content.trim().length < 3} className="btn-primary" data-testid="journal-save">
          {loading ? "Ukládám..." : "Uložit záznam"}
        </button>
      </div>
    </div>
  );
}
